export default {
      id: "Icon--download-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--download",
      toString: function () {
        return this.url;
      }
    }